import React from 'react';
import { motion } from 'framer-motion';
import { ClipboardList, Search, ShieldCheck, Handshake, PackageCheck, Ship } from 'lucide-react';
const steps = [{
  number: '01',
  title: 'Share Your Requirements',
  description: 'Tell us what products you need, target markets, volume requirements, and quality specifications.',
  icon: ClipboardList
}, {
  number: '02',
  title: 'Supplier Identification',
  description: 'We search our verified manufacturer network to find producers that match your exact specifications and standards.',
  icon: Search
}, {
  number: '03',
  title: 'Verification & Due Diligence',
  description: 'Factory audits, compliance checks, sample procurement, and supplier background verification.',
  icon: ShieldCheck
}, {
  number: '04',
  title: 'Negotiation & Contracts',
  description: 'We negotiate pricing, MOQs, payment terms, and secure supply contracts on your behalf.',
  icon: Handshake
}, {
  number: '05',
  title: 'Procurement & Quality Control',
  description: 'Order management, production oversight, quality inspections, and order consolidation.',
  icon: PackageCheck
}, {
  number: '06',
  title: 'Logistics & Market Delivery',
  description: 'Export documentation, customs clearance, freight management, and delivery to retail distribution points.',
  icon: Ship
}];
export function ProcessSection() {
  return <section id="process" className="py-24 bg-[#0a1628] relative overflow-hidden" data-id="element-437">
      {/* Background Pattern */}
      <div className="absolute inset-0 opacity-5 pointer-events-none" data-id="element-438">
        <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent" data-id="element-439" />
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-440">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-441">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-442">
            <span className="text-[#d4a853] font-medium tracking-[0.2em] uppercase text-sm block mb-4" data-id="element-443">
              Our Process
            </span>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-6" data-id="element-444">
              From Request to Delivery
            </h2>
            <p className="text-gray-400 text-lg" data-id="element-445">
              We manage every step of the sourcing journey so you can focus on
              growing your business.
            </p>
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 relative" data-id="element-446">
          {/* Connecting Line (Desktop) */}
          <div className="hidden lg:block absolute top-12 left-[16%] right-[16%] h-0.5 bg-gradient-to-r from-[#d4a853]/0 via-[#d4a853]/30 to-[#d4a853]/0 z-0" data-id="element-447" />

          {/* Connecting Line (Mobile/Tablet Vertical) */}
          <div className="lg:hidden absolute top-12 bottom-12 left-8 w-0.5 bg-gradient-to-b from-[#d4a853]/0 via-[#d4a853]/30 to-[#d4a853]/0 z-0" data-id="element-448" />

          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="relative z-10 group" data-id="element-449">
              <div className="bg-[#1a2d4a] border border-white/10 p-8 h-full hover:border-[#d4a853] transition-colors duration-300 relative overflow-hidden" data-id="element-450">
                {/* Decorative Number */}
                <div className="absolute -right-4 -top-4 text-8xl font-bold text-white/5 select-none group-hover:text-[#d4a853]/5 transition-colors" data-id="element-451">
                  {step.number}
                </div>

                <div className="flex items-center justify-between mb-6 relative" data-id="element-452">
                  <div className="w-12 h-12 bg-[#0a1628] border border-[#d4a853] flex items-center justify-center text-[#d4a853] group-hover:bg-[#d4a853] group-hover:text-[#0a1628] transition-all duration-300 shadow-[0_0_15px_rgba(212,168,83,0.2)]" data-id="element-453">
                    <step.icon size={24} data-id="element-454" />
                  </div>
                  <span className="text-[#d4a853] font-bold text-sm tracking-widest" data-id="element-455">
                    STEP {step.number}
                  </span>
                </div>

                <h3 className="text-xl font-bold text-white mb-3 group-hover:text-[#d4a853] transition-colors relative" data-id="element-456">
                  {step.title}
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed relative" data-id="element-457">
                  {step.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}